module.exports = __webpack_public_path__ + "static/media/24UHCHR3.bf092e3d.jpg";